import React, { useEffect, useState } from 'react';
import ProductDetailTabTypeDetailsFields from './ProductDetailTabTypeDetailsFields';

function EditProductDetailTabType({ TabTypeData, sendDataToParent }) {
  const [formData, setFormData] = useState(TabTypeData);

  useEffect(() => {
    setFormData(TabTypeData);
  }, [TabTypeData]);

  const handleData = (data) => {
    setFormData(data);
    if (sendDataToParent) sendDataToParent(data);
  };

  return (
    <div className="card-body px-0">
      <ProductDetailTabTypeDetailsFields
        formData={formData}
        sendDataToParent={handleData}
        isEdit
      />
    </div>
  );
}

export default EditProductDetailTabType;
